module.exports = __webpack_public_path__ + "static/img/sdfa.cccd817a.jpg";